import { render } from "./AppointmentPopover.vue?vue&type=template&id=648427c1"
import script from "./AppointmentPopover.vue?vue&type=script&lang=js"
export * from "./AppointmentPopover.vue?vue&type=script&lang=js"

import "./AppointmentPopover.vue?vue&type=style&index=0&id=648427c1&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__